import { css } from '@emotion/core'
import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import { Link } from './Link'

interface Props {
  content: string
  noLinks?: boolean
}

export const RichTextMarkdown: React.FC<Props> = ({ content, noLinks }) => {
  return (
    <ReactMarkdown
      children={content}
      remarkPlugins={[remarkGfm]}
      components={{
        link: (props: any) =>
          noLinks ? (
            <span>{props.children}</span>
          ) : (
            <Link className="opacity-on-hover" href={props.href}>
              {props.children}
            </Link>
          ),
        table: (props: any) => (
          <div css={tableScrollContainerStyle}>
            <table css={tableStyle}>{props.children}</table>
          </div>
        ),
        h1: (props: any) => <h1 className="heading1">{props.children}</h1>,
        h2: (props: any) => <h2 className="heading2">{props.children}</h2>,
        h3: (props: any) => <h3 className="heading3">{props.children}</h3>,
        h4: (props: any) => <h4 className="heading4">{props.children}</h4>,
        li: (props: any) => (
          <li css={listElementStyle}>
            <p className="paragraph">{props.children}</p>
          </li>
        ),
      }}
    />
  )
}

const tableScrollContainerStyle = css`
  overflow-x: auto;
  overflow-y: visible;
  margin-bottom: 2rem;
`

const tableStyle = css`
  border-collapse: collapse;

  th,
  td {
    min-width: 250px;
    border: 1px solid silver;
    text-align: left;
    vertical-align: top;
    padding: 5px;
  }
`

const listElementStyle = css`
  // overwrite all settings / styles from RichText
  &::before {
    font-size: 1rem !important;
    left: -1rem !important;
  }

  p.paragraph {
    margin-bottom: 0;
    font-size: 16px !important;
    line-height: 1.5rem !important;
  }
`
